// components/UnderDevelopment.js
import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const wave = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const PageContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #003366;
  background-size: 400% 400%;
  animation: ${wave} 8s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow-x: hidden;

  @media (max-width: 576px) {
    padding: 1rem;
  }
`;

const Content = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 576px) {
    padding: 1.5rem;
  }
`;

const Logo = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
  animation: ${pulse} 2s ease-in-out infinite;

  @media (max-width: 576px) {
    font-size: 3rem;
  }
`;

const Title = styled.h1`
  color: #003366;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 22ch;
  overflow-wrap: anywhere;

  @media (max-width: 576px) {
    font-size: 1.9rem;
  }
`;

const UnderDevelopment = () => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  useEffect(() => {
    const prevOverflowX = document.body.style.overflowX;
    const prevBg = document.body.style.background;
    document.body.style.overflowX = 'hidden';
    document.body.style.background = '#003366';
    return () => {
      document.body.style.overflowX = prevOverflowX;
      document.body.style.background = prevBg;
    };
  }, []);

  return (
    <PageContainer>
      <Content
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Logo>{isMaintenance ? '🚧' : '🌊'}</Logo>
        <Title>SITE UNDER MAINTENANCE</Title>
              
      </Content>
    </PageContainer>
  );
};

export default UnderDevelopment;
